// frontend/src/api/cart.js
import { apiClient } from './index';

const cartApi = {
  getCart: async () => {
    return await apiClient.get('/cart/');
  },

  addToCart: async (itemId, itemType = 'part', quantity = 1) => {
    return await apiClient.post('/cart/add', {
      item_id: itemId,
      item_type: itemType,
      quantity: quantity
    });
  },

  updateItem: async (itemId, quantity) => {
    return await apiClient.put('/cart/update', {
      item_id: itemId,
      quantity: quantity
    });
  },

  removeItem: async (itemId) => {
    return await apiClient.delete(`/cart/item/${itemId}`);
  },

  clearCart: async () => {
    return await apiClient.delete('/cart/');
  }
};

export { cartApi };